<card style="margin-left: -10px; margin-right: -10px; display: block">
  <form class="form m-0" (submit)="onSubmit($event)">
    <div class="field is-narrow">
      <label class="label" translationEditableDirective="CODE">{{
        'CODE' | translate
      }}</label>
      <div class="control">
        <span>{{ getField(['code']) }}</span>
      </div>
    </div>
    <div class="field is-narrow">
      <label class="label" translationEditableDirective="NAME">{{
        'NAME' | translate
      }}</label>
      <div class="control">
        <input
          class="input is-small"
          name="name"
          type="text"
          (input)="handleFieldChange($event)"
          [value]="getField(['name'])"
          [ngClass]="{ 'is-danger': hasError('name') }"
        />
      </div>
      <p class="help is-danger" *ngIf="hasError('name')">
        {{ getError('name') }}
      </p>
    </div>
    <div class="field is-narrow">
      <label class="label" translationEditableDirective="PROPERTIES">{{
        'PROPERTIES' | translate
      }}</label>
      <div class="control">
        <table
          *ngIf="!!getField(['compoundProperties']).size"
          class="table is-narrow"
          style="border: 1px solid #dbdbdb"
        >
          <thead>
            <tr>
              <th translationEditableDirective="PROPERTY_CODE">
                {{ 'PROPERTY_CODE' | translate }}
              </th>
              <th
                translationEditableDirective="PRIMARY"
                style="text-align: center"
              >
                {{ 'PRIMARY' | translate }}
              </th>
              <th></th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let row of getField(['compoundProperties'])">
              <td>
                <a
                  [routerLink]="[
                    '/properties',
                    row.get('propertyId'),
                    'details'
                  ]"
                  >{{ row.get('propertyCode') }}</a
                >
              </td>
              <td style="text-align: center">
                <input
                  type="radio"
                  name="primary"
                  [value]="row.get('propertyCode')"
                  [checked]="row.get('isPrimary')"
                  (change)="makePrimary(row)"
                />
              </td>
              <td style="text-align: end">
                <button
                  type="button"
                  class="button is-danger is-small"
                  (click)="deleteProperty(row)"
                >
                  <span class="icon is-small">
                    <i class="fas fa-times"></i>
                  </span>
                </button>
              </td>
            </tr>
          </tbody>
        </table>
        <button
          type="button"
          class="button is-success is-small"
          (click)="isOpen = true"
          translationEditableDirective="ADD_PROPERTIES"
        >
          {{ 'ADD_PROPERTIES' | translate }}
        </button>
      </div>
      <p class="help is-danger" *ngIf="hasError('compoundProperties')">
        {{ getError('compoundProperties') }}
      </p>
    </div>
  </form>
</card>

<div class="field is-grouped">
  <div class="control">
    <button
      [disabled]="isLoading"
      type="submit"
      class="button is-success"
      translationEditableDirective="SUBMIT"
      (click)="onSubmit($event)"
    >
      {{ 'SUBMIT' | translate }}
    </button>
  </div>
  <div class="control">
    <a
      [routerLink]="['/compounds']"
      class="button is-link is-light"
      translationEditableDirective="CANCEL"
      >{{ 'CANCEL' | translate }}</a
    >
  </div>
</div>

<div class="modal is-active" *ngIf="isOpen">
  <div class="modal-background"></div>
  <div class="modal-card" style="width: 380px; overflow: visible">
    <div class="modal-card-head">
      <span
        class="modal-card-title"
        translationEditableDirective="ADD_PROPERTIES"
      >
        {{ 'ADD_PROPERTIES' | translate }}
      </span>
      <button
        (click)="isOpen = false"
        class="delete"
        aria-label="close"
        type="button"
      ></button>
    </div>
    <div class="modal-card-body p-5" style="overflow: visible">
      <ng-select
        [items]="propertiesOptions"
        [multiple]="true"
        [closeOnSelect]="true"
        (change)="selectedProperties = $event"
        [ngClass]="{
          'is-danger': hasError('propertyId')
        }"
        bindLabel="name"
        bindValue="id"
        [ngModelOptions]="{ standalone: true }"
        [ngModel]="selectedProperties || null"
        [typeahead]="onPropertyAutocomplete$"
        [compareWith]="compareFn"
      >
      </ng-select>
    </div>
    <footer class="modal-card-foot">
      <button
        class="button is-success"
        translationEditableDirective="SAVE"
        [disabled]="!selectedProperties.length"
        type="button"
        (click)="handleFieldChange(selectedProperties, 'compoundProperties')"
      >
        {{ 'SAVE' | translate }}
      </button>
      <button
        class="button"
        type="button"
        (click)="isOpen = false"
        translationEditableDirective="CANCEL"
      >
        {{ 'CANCEL' | translate }}
      </button>
    </footer>
  </div>
</div>
